function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  stroke: "#F01919",
  strokeWidth: 4,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero-box-without-animation_svg__hero-box-polyline",
  d: "M1305 44h86v228h-85.56M1287 44h-86v228h85.56"
}));

var SvgHeroBoxWithoutAnimation = function SvgHeroBoxWithoutAnimation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 2000,
    height: 330,
    viewBox: "0 0 2000 330"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/hero-box-without-animation.3e8771d8.svg";
export { SvgHeroBoxWithoutAnimation as ReactComponent };